/** `reason` query value AuthContext sets when it sends the user to /login after the session ends. */
export const SESSION_ENDED_REASON = "session-expired";

/** Copy shown on the login page for that redirect, or null for an ordinary visit. */
export function sessionEndedMessage(search: string): string | null {
	const params = new URLSearchParams(search);
	return params.get("reason") === SESSION_ENDED_REASON ? "Your session has ended. Please sign in again." : null;
}
